import React, { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Slider,
} from "@nextui-org/react";

import "./IncomeGoalsPopup.css";
import { NumericFormat } from "react-number-format";

function IncomeGoalsPopup(props) {
  const [insuranceGoal, setInsuranceGoal] = useState(props.defaultInsuranceGoal);
  const [investmentGoal, setInvestmentGoal] = useState(props.defaultInvestmentGoal);
  const [averageCaseSize, setAverageCaseSize] = useState(props.defaultAverageCaseSize);
  const [saving, setSaving] = useState(false);

  const inputCleanAndValidate = (input) => {
    if (input < 0) {
      return 0;
    }

    return Math.round(input);
  };

  const saveCallback = (status) => {
    if (status == "ERROR") {
      setSaving(false);
    } else {
      setSaving(false);
      handleClose();
    }
  };

  const onSave = () => {
    setSaving(true);

    const cleanInsuranceGoal = inputCleanAndValidate(insuranceGoal);
    const cleanInvestmentGoal = inputCleanAndValidate(investmentGoal);
    const cleanAverageCaseSize = inputCleanAndValidate(averageCaseSize);

    setInsuranceGoal(cleanInsuranceGoal);
    setInvestmentGoal(cleanInvestmentGoal);
    setAverageCaseSize(cleanAverageCaseSize);

    props.handleSave(cleanInsuranceGoal, cleanInvestmentGoal, cleanAverageCaseSize, saveCallback);
  };

  const handleClose = () => {
    props.handleClose();
  };

  const onOpenChange = (isOpen) => {
    if (!isOpen) {
      handleClose();
    }
  };

  return (
    <Modal isOpen={props.open} onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 text-center text-2xl font-bold text-[#002e62]">
              Income Settings
            </ModalHeader>
            <ModalBody>
              <div>
                <NumericFormat
                  customInput={Input}
                  label="Yearly Insurance Income Goal"
                  value={insuranceGoal}
                  onValueChange={(values) => setInsuranceGoal(values.value)}
                  thousandSeparator
                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-default-400 text-small">$</span>
                    </div>
                  }
                  className="px-2"
                />
                <Slider
                  step={1000}
                  maxValue={1000000}
                  minValue={0}
                  value={insuranceGoal}
                  onChange={setInsuranceGoal}
                  className="max-w-md mt-3"
                />
              </div>
              <div>
                <NumericFormat
                  customInput={Input}
                  label="Average Case Size"
                  value={averageCaseSize}
                  onValueChange={(values) => setAverageCaseSize(values.value)}
                  thousandSeparator
                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-default-400 text-small">$</span>
                    </div>
                  }
                  className="px-2"
                />
                <Slider
                  maxValue={10000}
                  minValue={0}
                  value={averageCaseSize}
                  onChange={setAverageCaseSize}
                  className="max-w-md mt-3"
                />
              </div>
            </ModalBody>
            <ModalFooter className="flex justify-center">
              <Button color="primary" isLoading={saving} onPress={onSave}>
                Save
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      prefix="$"
    />
  );
});

export default IncomeGoalsPopup;
